import React from 'react';
import './Cali.css'; 

const Rionegro = () => {
  return (
   <div>
    <div className='Espacio-titulo'>
    <h1><a className='Titulo' href="/aip/SKRG.pdf" target="_blank" rel="noreferrer">Aeropuerto José María Córdova</a></h1>
    </div>

    <div className='containeraeropuertos'>
      
      <div className='subcontaineraeropuertos'>
        <h1>SID</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 01</th>                      
          </tr>  
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/BUTA3A.pdf" target="_blank" rel="noreferrer">BUTA3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/BUTA3A.pdf" target="_blank" rel="noreferrer">DABI3B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/BUTA3A.pdf" target="_blank" rel="noreferrer">KOTI3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/BUTA3A.pdf" target="_blank" rel="noreferrer">OPME3C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/IBDA1A.pdf" target="_blank" rel="noreferrer">IBDA1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/ISVA2B.pdf" target="_blank" rel="noreferrer">ISVA2B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/ISVA2B.pdf" target="_blank" rel="noreferrer">MUGO2B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/ISVA2B.pdf" target="_blank" rel="noreferrer">RNG2B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/LATI2A.pdf" target="_blank" rel="noreferrer">LATI2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/LATI2A.pdf" target="_blank" rel="noreferrer">BIVI3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/LATI2A.pdf" target="_blank" rel="noreferrer">MRN1C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/TEDO1B.pdf" target="_blank" rel="noreferrer">TEDO1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/TEDO1B.pdf" target="_blank" rel="noreferrer">KORB1C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/TEDO1B.pdf" target="_blank" rel="noreferrer">LATI1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/TEDO1B.pdf" target="_blank" rel="noreferrer">BIVI1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/TEDO1B.pdf" target="_blank" rel="noreferrer">OTU1C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/TEDO1B.pdf" target="_blank" rel="noreferrer">DIPR1C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/GEBA1A.pdf" target="_blank" rel="noreferrer">GEBA1A</a></th>
          </tr>
              
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 19</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/DABI1C.pdf" target="_blank" rel="noreferrer">DABI1C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/DABI1C.pdf" target="_blank" rel="noreferrer">VULR1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/DABI1C.pdf" target="_blank" rel="noreferrer">ISVO1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/LLIX2A.pdf" target="_blank" rel="noreferrer">LLIX2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/LLIX2A.pdf" target="_blank" rel="noreferrer">DIPR2E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/MRN5B.pdf" target="_blank" rel="noreferrer">MRN5B</a></th>
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>STAR</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 01</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/NIRS4A.pdf" target="_blank" rel="noreferrer">NIRS4A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/MATR6A.pdf" target="_blank" rel="noreferrer">MATR6A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/RENO3A.pdf" target="_blank" rel="noreferrer">RENO3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/RNG4C.pdf" target="_blank" rel="noreferrer">RNG4C</a></th>
          </tr>
          <tr>            
            <th className='Procedimientos'><a href="/regionales/SKRG/LATI3C.pdf" target="_blank" rel="noreferrer">LATI3C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/LATI3C.pdf" target="_blank" rel="noreferrer">BIVI3C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/LATI3C.pdf" target="_blank" rel="noreferrer">OTU3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/LATI3C.pdf" target="_blank" rel="noreferrer">DIPR3B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/LATI3C.pdf" target="_blank" rel="noreferrer">AKSE3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/LATI3C.pdf" target="_blank" rel="noreferrer">MRN3D</a></th>
          </tr>        
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/AKPE4C.pdf" target="_blank" rel="noreferrer">AKPE4C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/AKPE4C.pdf" target="_blank" rel="noreferrer">ARTU4A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/AKPE4C.pdf" target="_blank" rel="noreferrer">ISPA3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/AKPE4C.pdf" target="_blank" rel="noreferrer">KORB3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/AKPE4C.pdf" target="_blank" rel="noreferrer">NENE3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/AKPE4C.pdf" target="_blank" rel="noreferrer">OPME4A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/AKPE4C.pdf" target="_blank" rel="noreferrer">TEDO3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/ISVO4A.pdf" target="_blank" rel="noreferrer">ISVO4A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/ISVO4A.pdf" target="_blank" rel="noreferrer">NIRS3C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/ISVO4A.pdf" target="_blank" rel="noreferrer">RENO3B</a></th>
          </tr>
          
          </table>

          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 19</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/LATI3C.pdf" target="_blank" rel="noreferrer">LATI3C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/LATI3C.pdf" target="_blank" rel="noreferrer">BIVI3C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/LATI3C.pdf" target="_blank" rel="noreferrer">OTU3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/LATI3C.pdf" target="_blank" rel="noreferrer">DIPR3B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/LATI3C.pdf" target="_blank" rel="noreferrer">AKSE3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/LATI3C.pdf" target="_blank" rel="noreferrer">MRN3D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/AKPE4C.pdf" target="_blank" rel="noreferrer">AKPE4C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/AKPE4C.pdf" target="_blank" rel="noreferrer">ARTU4A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/AKPE4C.pdf" target="_blank" rel="noreferrer">ISPA3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/AKPE4C.pdf" target="_blank" rel="noreferrer">KORB3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/AKPE4C.pdf" target="_blank" rel="noreferrer">NENE3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/AKPE4C.pdf" target="_blank" rel="noreferrer">OPME4A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/AKPE4C.pdf" target="_blank" rel="noreferrer">TEDO3A</a></th>
          </tr>

          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>IAC</h1>
        <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 01</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/ILSY01.pdf" target="_blank" rel="noreferrer">ILS Y</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/ILSZ01.pdf" target="_blank" rel="noreferrer">ILS Z</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/LOC01.pdf" target="_blank" rel="noreferrer">LOC</a></th>
          </tr>          
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/RNP01.pdf" target="_blank" rel="noreferrer">RNP</a></th>
          </tr>
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 19</th>                      
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/RNPA19.pdf" target="_blank" rel="noreferrer">RNP A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKRG/RNPB19.pdf" target="_blank" rel="noreferrer">RNP B</a></th>
          </tr>
          </table>
        </div>
      </div>

    </div>

  </div>
  );
};
export default Rionegro;